module.exports = __webpack_public_path__ + "img/icon_mokuai.5b72ccf1.png";